import { useTranslation } from "@equiem/web-ng-lib";
import React from "react";
import { ProductBookableListingFragment } from "../../../generated/gateway-client";
import { PriceFormat } from "../../PriceFormat";
import { ProductListing } from "./ProductListing";
import { FaStore } from "react-icons/fa";

interface Props {
  product: ProductBookableListingFragment;
  className?: string;
  metric?: {
    ns: string;
    nx: number;
  };
  showVendor?: boolean;
}

export const ListingBookable: React.FC<Props> = ({ metric, product, className = "", showVendor = true }) => {
  const { t } = useTranslation();

  const metricExt = metric == null ? "" : `?ns=${metric.ns}&nx=${metric.nx}`;

  return (
    <ProductListing
      className={className}
      name={product.name}
      image={product.image}
      available={product.available}
      outOfStock={product.outOfStock}
      description={product.description}
      url={{
        as: `/store/booking/${product.uuid}${metricExt}`,
        href: "/store/booking/[uuid]",
      }}
    >
      <div className="mt-auto">
        {showVendor ? (
          <div className="vendor-name pb-3 d-flex">
            <div><FaStore /></div> <span className="ml-2">{product.vendor.name}</span>
          </div>
        ) : null}
        <div className="price">
          <PriceFormat price={product.unitPrice} freeTxt={t("main.free")} />
          {product.availability.limitedAvailability ? <span>{" "}({t("main.restrictedAvailability")})</span> : null}
        </div>
      </div>
    </ProductListing>
  );
}
